module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.user != '') ? _c('div', {
    staticClass: "wrapper"
  }, [_c('HTMLHeader'), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.fill_info == '' && _vm.hianypotlas_fields.length > 0) ? _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("ÚNKP hiánypótlás")]), _vm._v(" "), (_vm.hianypotlas_megj != '') ? _c('div', {
    staticClass: "info-box warning"
  }, [_vm._v(_vm._s(_vm.hianypotlas_megj))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.hianypotlas_fields), function(hf) {
    return (hf.hianypotlas.complete == 0) ? _c('UploadHandler', {
      key: hf.form_field_key,
      attrs: {
        "msg": hf.hianypotlas.msg,
        "max_uploaded_files": hf.hianypotlas.feltoltheto_fajl_db,
        "accepted_files": hf.form_field_key == 'palyazati_adatlap_szerkesztheto' ? 'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' : 'image/jpeg,application/pdf,application/x-pdf',
        "errors": _vm.errors,
        "id": hf.form_field_key,
        "label": hf.form_field_name,
        "name": hf.form_field_key
      },
      on: {
        "change": function (value) {
          _vm.changeValue(value, hf.form_field_key);
        }
      }
    }) : _vm._e()
  }), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "type": "button",
      "name": "kuld"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Hiánypótlás beküldése")])], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.fill_info != '') ? _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("ÚNKP hiánypótlás")]), _vm._v(" "), _c('div', {
    staticClass: "article-text"
  }, [_vm._v("\n            " + _vm._s(_vm.fill_info) + "\n          ")])])])])]) : _vm._e(), _vm._v(" "), _c('HTMLFooter'), _vm._v(" "), _c('ProfileMenu')], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subpage-head-image",
    staticStyle: {
      "background-image": "url('assets/img/subpage-head.jpg')"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("\n        ÚNKP\n        "), _c('span', [_vm._v("Hiánypótlás")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-312f19da"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/competition/unkp2021_hianypotlas.vue
// module id = 349
// module chunks = 0